import React from 'react'
import News from './News'  
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = { 
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,  
    arrows:false,
    adaptiveHeight: true, 
  };
  return (
   <>
   <div className="slider-sec"> 
   <div className='news'>
    <News />
   </div>
   <div className='homeslider'>
       {  /* <div className="bannervideo">
             <div className="bannervideoimg">
             <iframe src="https://www.youtube.com/embed/PtjcYXfQHJQ?playlist=PtjcYXfQHJQ&amp;loop=1&amp;autoplay=1&amp;mute=1&amp;rel=0&amp;modestbranding=1&amp;controls=0&amp;showinfo=0" title="Background video" frameborder="0" allow="autoplay" allowfullscreen=""></iframe>
             </div>
        </div> */}
      <Slider {...settings}>  
   <div className="item">
         <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/slider1.jpg" className="d-block w-100" alt="SPCSH"/> 
    </div> 
    <div className="item">
         <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/slider2.jpg" className="d-block w-100" alt="SPCSH"/> 
    </div> 
    <div className="item">
         <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/slider3.jpg" className="d-block w-100" alt="SPCSH"/> 
    </div>  
    <div className="item">
    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/slider4.jpg" className="d-block w-100" alt="SPCSH"/> 
</div> 
<div className="item">
    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/slider6.jpg" className="d-block w-100" alt="SPCSH"/> 
</div> 
<div className="item">
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/slider5.jpg" className="d-block w-100" alt="SPCSH"/> 
</div> 
  </Slider>  
   </div> 
   </div>
   </>
  )
}

export default HomeSlider
